import React from "react";

/* Simple hand-drawn marks for the whiteboard look. pathLength="1" lets CSS draw them in. */

export const CircleMark = ({ className = "" }) => (
  <svg
    className={`sketch-mark sketch-circle ${className}`}
    viewBox="0 0 120 60"
    preserveAspectRatio="none"
    aria-hidden="true"
    focusable="false"
  >
    <path pathLength="1" d="M10 30 C 8 12, 42 4, 70 6 C 102 8, 118 20, 113 37 C 108 53, 62 58, 32 52 C 12 48, 3 38, 14 20" />
  </svg>
);

export const ScribbleLine = ({ className = "" }) => (
  <svg
    className={`sketch-mark sketch-underline ${className}`}
    viewBox="0 0 300 24"
    preserveAspectRatio="none"
    aria-hidden="true"
    focusable="false"
  >
    <path pathLength="1" d="M3 16 C 60 7, 118 20, 176 10 S 262 6, 297 13" />
  </svg>
);

export const HandArrow = ({ className = "" }) => (
  <svg
    className={`sketch-mark sketch-arrow ${className}`}
    viewBox="0 0 64 48"
    aria-hidden="true"
    focusable="false"
  >
    <path pathLength="1" d="M4 44 C 20 40, 40 30, 54 10" />
    <path pathLength="1" d="M54 10 L 41 13 M54 10 L 53 23" />
  </svg>
);
